import React from "react";
import { Helmet } from "react-helmet";



function Home() {
  return (
    <>

    <Helmet>
        <title>LifeGuardian - ระบบแจ้งเตือน</title>
        <meta
          name="description"
          content="ระบบแจ้งเตือนแผ่นดินไหวแบบเรียลไทม์ ด้วย MQTT และ API จากแหล่งข้อมูลต่างประเทศ พร้อมแสดงผลแบบเข้าใจง่าย"
        />
    </Helmet>

      {/* Hero Banner แบบสไลด์ */}
      <div id="heroCarousel" className="carousel slide" data-bs-ride="carousel">
          <div className="carousel-inner">        

            {/* Slide 0 */}
            <div className="carousel-item active">
              <div
                className="d-flex align-items-center justify-content-center text-white"
                style={{
                  height: "60vh",
                  backgroundImage: "url('/rip.jpg')",
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  backgroundColor: "#000",
                  textShadow: "1px 1px 3px rgba(0,0,0,0.7)"
                }}
              >
                <div
                    className="text-center px-4 py-2"
                    style={{
                      backgroundColor: "rgba(0, 0, 0, 0.5)",
                      borderRadius: "12px"
                    }}
                  >
                  
                  
                </div>
              </div>
            </div>


            {/* Slide 1 */}
            <div className="carousel-item">
              <div
                className="d-flex align-items-center justify-content-center text-white"
                style={{
                  height: "60vh",
                  backgroundImage: "url('/slide1.png')",
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  backgroundColor: "#000",
                  textShadow: "1px 1px 3px rgba(0,0,0,0.7)"
                }}
              >
                <div
                    className="text-center px-4 py-2"
                    style={{
                      backgroundColor: "rgba(0, 0, 0, 0.5)",
                      borderRadius: "12px"
                    }}
                  >
                  <h1 className="display-4 fw-bold">เตือนแผ่นดินไหว</h1>
                  <p className="lead">พร้อมรับมือทันที เมื่อเกิดภัยพิบัติ</p>
                </div>
              </div>
            </div>

            {/* Slide 2 */}
            <div className="carousel-item">
              <div
                className="d-flex align-items-center justify-content-center text-white"
                style={{
                  height: "60vh",
                  backgroundImage: "url('/slide2.jpg')",
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  backgroundColor: "#000",
                  textShadow: "1px 1px 3px rgba(0,0,0,0.7)"
                }}

              >
                 <div
                    className="text-center px-4 py-2"
                    style={{
                      backgroundColor: "rgba(0, 0, 0, 0.5)",
                      borderRadius: "12px"
                    }}
                  >
                  <h1 className="display-4 fw-bold">เตือนเพลิงไหม้</h1>
                  <p className="lead">จัดกลุ่มแจ้งเตือน พร้อมกันหลายเครื่องได้</p>
                </div>
              </div>
            </div>

            {/* Slide 3 */}
            <div className="carousel-item">
              <div
                className="d-flex align-items-center justify-content-center text-white"
                style={{
                  height: "60vh",
                  backgroundImage: "url('/slide3.png')",
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  backgroundColor: "#000",
                  textShadow: "1px 1px 3px rgba(0,0,0,0.7)"
                }}
              >
                 <div
                    className="text-center px-4 py-2"
                    style={{
                      backgroundColor: "rgba(0, 0, 0, 0.5)",
                      borderRadius: "12px"
                    }}
                  >
                  <h1 className="display-4 fw-bold">ขอความช่วยเหลือ</h1>
                  <p className="lead">จัดกลุ่มแจ้งเตือน พร้อมกันหลายเครื่องได้</p>
                </div>
              </div>
            </div>

            {/* Slide 4 */}
            <div className="carousel-item">
              <div
                className="d-flex align-items-center justify-content-center text-white"
                style={{
                  height: "60vh",
                  backgroundImage: "url('/slide4.png')",
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  backgroundColor: "#000",
                  textShadow: "1px 1px 3px rgba(0,0,0,0.7)"
                }}
              >
                 <div
                    className="text-center px-4 py-2"
                    style={{
                      backgroundColor: "rgba(0, 0, 0, 0.5)",
                      borderRadius: "12px"
                    }}
                  >
                  <h1 className="display-4 fw-bold">ความปลอดภัย</h1>
                  <p className="lead">สามารถใช้ แจ้งเตือนใน องค์กร</p>
                </div>
              </div>
            </div>

           

          </div>

          {/* Control arrows */}
          <button className="carousel-control-prev" type="button" data-bs-target="#heroCarousel" data-bs-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button className="carousel-control-next" type="button" data-bs-target="#heroCarousel" data-bs-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
          </button>
      </div>

      <section className="bg-light py-5 text-center border-top border-bottom">
        <div className="container">
          <h2 className="fw-bold mb-3">
            <span className="text-dark">Life</span>
            <span className="text-dark">Guardian</span> คืออะไร?
          </h2>
         <p className="fs-5 mx-auto" style={{ maxWidth: "800px" }}>
            <span className="fw-bold text-dark">Life</span>
            <span className="fw-bold text-dark">Guardian</span> คือแพลตฟอร์มแจ้งเตือนเหตุฉุกเฉินและควบคุมอุปกรณ์ IoT แบบเรียลไทม์<br />
            ผู้ใช้งานสามารถแบ่งกลุ่มอุปกรณ์ แจ้งเตือนเฉพาะพื้นที่ และติดตามการตอบสนองจากแต่ละจุด<br />
            ระบบรองรับข้อมูลจากหลายแหล่ง เช่น TMD, USGS และออกแบบให้รองรับการอัปเดต OTA 
          </p>
        </div>
      </section>
    
    <nav className="text-center mb-5">
      <h5 className="fw-bold text-primary">🗂️ สารบัญ</h5>
      <div className="d-flex flex-wrap justify-content-center gap-2 mt-3">        
        <a href="#card1" className="menu-button">LifeGuardian</a>
        <a href="#card2" className="menu-button">โครงสร้างระบบ</a>
        <a href="#card3" className="menu-button">ข้อมูลอ้างอิง</a>
        <a href="#card4" className="menu-button">MQTT คืออะไร</a>
        <a href="#card5" className="menu-button">InSAR คืออะไร?</a>       
      </div>
    </nav>


    
    <div className="container mt-5" style={{ paddingBottom: "50px" }}>
      <div className="row justify-content-center g-4">
      
        {/* Card 1: LifeGuardian Overview */}
        <section id="card1" className="container my-4">
          <article className="card mx-auto shadow text-start" style={{ maxWidth: "700px" }}>
            
            <div className="p-3">
              <img
                src="esp32_1.jpg"
                className="card-img-top"
                alt="หน้าจอแสดงผลอุปกรณ์แจ้งเตือนแผ่นดินไหว LifeGuardian"
                style={{
                  maxHeight: "300px",
                  objectFit: "contain",
                  width: "100%"
                }}
              />
            </div>

            <div className="card-body">
              <h2 className="card-title fw-bold text-primary text-decoration-underline mb-3 text-center">
                ระบบแจ้งเตือนแผ่นดินไหว 
              </h2>

              {/* ✅ แสดงเฉพาะ Desktop / Tablet */}
              <p className="card-text fs-5 d-none d-md-block">
                อุปกรณ์แสดงข้อความพร้อมเสียงร้องเตือน รองรับภาษาไทย<br />
                ทำงานตลอด 24 ชั่วโมง พร้อมเชื่อมต่อ Wi-Fi<br /><br />
                อัปเดตข้อมูลโดยอัตโนมัติจากแหล่งข้อมูลแผ่นดินไหว<br />
                ช่วยให้มั่นใจว่าระบบทำงานได้ถูกต้อง<br />
                และสามารถตั้งค่าการแจ้งเตือนได้ด้วยตนเอง
              </p>

              {/* ✅ แสดงเฉพาะมือถือ */}
              <p className="card-text fs-6 d-block d-md-none text-center">
                อุปกรณ์แสดงข้อความ+เสียง<br />
                รองรับภาษาไทย<br />
                อัปเดตอัตโนมัติ 24 ชม.<br />
                เชื่อม Wi-Fi ได้<br /><br />
                ตั้งค่า แจ้งเตือนเอง ได้เอง<br />
                ใช้งานง่าย
              </p>
            </div>

          </article>
        </section>

        {/* Card 2: System Architecture */}
        <section id="card2" className="container my-4">
          <article className="card mx-auto shadow text-start" style={{ maxWidth: "700px" }}>
            <div className="p-3">
              <img
                src="network.png"
                className="card-img-top"
                alt="ภาพโครงสร้างระบบ LifeGuardian ดึงข้อมูลจาก API และส่งผ่าน MQTT"
                style={{
                  maxHeight: "400px",
                  objectFit: "contain",
                  width: "100%"
                }}
              />
            </div>
            <div className="card-body">
              <h2 className="card-title fw-bold text-decoration-underline text-center">
                โครงสร้างการทำงาน LifeGuardian 
              </h2>


              {/* ✅ แสดงเฉพาะ Desktop / Tablet */}
              <p className="card-text fs-5 d-none d-md-block">
                <strong>SERVER</strong> ทำงานตลอด 24 ชั่วโมง ดึงข้อมูลเหตุการณ์แผ่นดินไหวจากแหล่งต่าง ๆ ด้วย API และอ่านข้อมูลรายงานจากหน้าเว็บ โดยมีเจ้าหน้าที่คอยติดตามเหตุการณ์อย่างใกล้ชิด
                <br /><br />
                เมื่อเกิดเหตุการณ์ ระบบจะส่งข้อความผ่าน <strong>MQTT</strong>  เหมาะสำหรับระบบ <strong>IoT</strong> ที่มีอุปกรณ์จำนวนมาก และต้องการการสื่อสารที่รวดเร็วและประหยัดทรัพยากร
              </p>

              {/* ✅ แสดงเฉพาะมือถือ */}
              <p className="card-text fs-6 d-block d-md-none text-center">
                <strong>SERVER</strong> ทำงานตลอด 24 ชม.<br />
                ดึงข้อมูลแผ่นดินไหวจากหลายที่<br />
                อ่านรายงานจากหน้าเว็บ<br />
                เจ้าหน้าที่ติดตามอย่างใกล้ชิด<br /><br />
                ระบบส่งข้อมูลผ่าน <strong>MQTT</strong><br />
                เหมาะกับ <strong>IoT</strong> ที่มีอุปกรณ์มาก<br />
                รวดเร็ว ประหยัดทรัพยากร
              </p>
            </div>
          </article>
        </section>

        {/* ✅ Card 3: API References */}
        <section  id="card3" className="container my-4">
            <article className="card text-center mx-auto shadow" style={{ maxWidth: "700px" }}>
              <div className="card-body">
                <h2 className="card-title fw-bold text-primary text-decoration-underline">
                  ข้อมูลอ้างอิง
                </h2>
                <p className="card-text fs-5">
                  ระบบนี้ดึงข้อมูลจาก <strong>4 แหล่งหลัก</strong> เพื่อให้ครอบคลุมและเชื่อถือได้:<br /><br />
                  
                  🔹 <strong>TMD (กรมอุตุนิยมวิทยา):</strong><br />
                  <a 
                    href="https://tmd.go.th/" 
                    target="_blank" 
                    rel="noreferrer"
                  >
                    https://tmd.go.th/
                  </a><br /><br />

                  🔹 <strong>USGS (U.S. Geological Survey):</strong><br />
                  <a 
                    href="https://www.usgs.gov" 
                    target="_blank" 
                    rel="noreferrer"
                  >
                    https://www.usgs.gov
                  </a><br /><br />

                  🔹 <strong>EMSC (European-Mediterranean Seismological Centre):</strong><br />
                  <a 
                    href="https://www.emsc-csem.org" 
                    target="_blank" 
                    rel="noreferrer"
                  >
                    https://www.emsc-csem.org
                  </a><br /><br />

                  🔹 <strong>InSAR (Interferometric Synthetic Aperture Radar):</strong><br />
                  <a 
                    href="https://www.eoportal.org/other-space-activities/earthquakes-insar#interferograms" 
                    target="_blank" 
                    rel="noreferrer"
                  >
                    https://www.eoportal.org/other-space-activities/earthquakes-insar#interferograms
                  </a>
                </p>
              </div>
            </article>
        </section>

        {/* ✅ Card 4: ทำความรู้จักกับ MQTT */}
          <section  id="card4" className="container my-4">
            <article className="card text-center mx-auto shadow" style={{ maxWidth: "700px" }}>
              <div className="card-body">
                <h2 className="card-title fw-bold text-primary text-decoration-underline">
                  MQTT คืออะไร?
                </h2>
                <p className="card-text fs-5 text-start">
                  <strong>MQTT</strong> (Message Queuing Telemetry Transport) คือโปรโตคอล...
                </p>

                <ul className="card-text fs-5 text-start">
                  <li>สื่อสารผ่านระบบ Publish/Subscribe</li>
                  <li>ใช้ Bandwidth ต่ำ เหมาะกับอุปกรณ์ที่มีพลังงานจำกัด</li>
                  <li>ตอบสนองเร็วและมีความเสถียรสูง</li>
                  <li>เหมาะกับการแจ้งเตือนเหตุการณ์ เช่น แผ่นดินไหว</li>
                </ul>

                <p className="card-text fs-5 text-start">
                  LifeGuardian เลือกใช้ MQTT เพื่อให้ระบบแจ้งเตือน...
                  <br /><br />
                  🔗 <a href="https://aws.amazon.com/th/what-is/mqtt/" target="_blank" rel="noreferrer">
                    ข้อมูลเพิ่มเติมจาก AWS
                  </a>
                </p>

              </div>
            </article>
          </section>

          {/* ✅ Card 5: Raspberry Shake คืออะไร */}
          <section  id="card5" className="container my-4">
            <article className="card text-center mx-auto shadow" style={{ maxWidth: "700px" }}>
              <div className="card-body">
                <h2 className="card-title fw-bold text-primary text-decoration-underline">
                  InSAR คืออะไร?
                </h2>
                <p className="card-text fs-5 text-start">
                    <strong>InSAR (Interferometric Synthetic Aperture Radar)</strong>คือเทคนิคการวัดการเคลื่อนตัวของพื้นดิน โดยใช้ภาพเรดาร์จากดาวเทียมสองช่วงเวลา มาคำนวณความต่างของคลื่น (phase difference) เพื่อดูการเปลี่ยนแปลงระดับพื้นผิว เช่น การทรุดตัวหรือยกตัวจากแผ่นดินไหว
                  </p>

                  <p className="card-text fs-5 text-start">
                    จุดเด่นของ InSAR:
                  </p>

                  <ul className="card-text fs-5 text-start">
                    <li>ไม่ต้องติดตั้งเครื่องมือภาคพื้นดิน</li>
                    <li>ครอบคลุมพื้นที่กว้างหลายร้อยกิโลเมตร</li>                    
                  </ul>

                  <p className="card-text fs-5 text-start">
                   
                    <br /><br />
                    🔗 <a href="https://www.eoportal.org/other-space-activities/earthquakes-insar#interferograms" target="_blank" rel="noreferrer">
                      ข้อมูลเพิ่มเติมจากเว็บไซต์: Earthquakes (InSAR)
                    </a>
                  </p>

              </div>
            </article>
          </section>   


      </div>
    </div>
    </>
  );
}

export default Home;
